import React, { useState } from 'react';
import { toast } from 'react-toastify';

const TopMoreMenu = ({
    moreMenuView,
    setMoreMenuView,
    currentStatus,
    navigate,
    setSelectedStatus,
    setStatusText,
    setShowStatusModal,
    setShowMoreMenu,
    setShowCustomDndModal,
    setShowDndScheduleModal,
    handleQuickDnd,
    dndBypassRules,
    toggleDndBypassRule,
    savedDndSchedules,
    setSavedDndSchedules,
    setCurrentStatus,
    getAuthHeaders,
    activeStatuses = [],
}) => {

    const [expandedStatus, setExpandedStatus] = useState(null);
    const [selectedActiveStatus, setSelectedActiveStatus] = useState(null);
    const statusToShow = activeStatuses[0] || currentStatus;

    const formatStatusTime = (status) => {
        if (status?.expiresAt) {
            return `Until ${new Date(status.expiresAt).toLocaleTimeString([], {
                hour: 'numeric',
                minute: '2-digit',
            })}`;
        }

        if (status?.untilTime) return `Until ${status.untilTime}`;
        if (status?.endTime) return `Until ${status.endTime}`;

        return 'Active';
    };

    const handleTurnOffSingleStatus = async (status) => {
        try {
            const statusId = status?._id || status?.id;

            if (!statusId) {
                toast.error('Unable to find this status');
                return;
            }

            const res = await fetch(`/api/availability/${statusId}`, {
                method: 'PATCH',
                headers: getAuthHeaders(),
                body: JSON.stringify({ enabled: false }),
            });

            if (!res.ok) {
                throw new Error('Failed to turn off status');
            }

            window.dispatchEvent(new Event('kuddle:availability-updated'));
            setMoreMenuView('main');
            setSelectedActiveStatus(null);
            setCurrentStatus(null);
        } catch (err) {
            console.error(err);
            toast.error('Unable to turn off this status');
        }
    };

    return (
        <div className="top-more-menu">
            {moreMenuView === 'main' && (
                <>
                    <p className="top-more-section-title">Tools</p>

                    {activeStatuses.length > 0 && (
                        <button type="button" onClick={() => setMoreMenuView('dnd')}>
                            {activeStatuses.length} Active Block{activeStatuses.length > 1 ? 's' : ''}
                        </button>
                    )}

                    <button type="button" onClick={() => navigate('/calendar')}>
                        📅 Calendar
                    </button>

                    <button type="button" onClick={() => navigate('/notepad')}>
                        📝 Notepad
                    </button>

                    <p className="top-more-section-title">Settings</p>

                    <button type="button">⚙️ Message Settings</button>
                </>
            )}

            {moreMenuView === 'dnd' && (
                <>
                    <button
                        type="button"
                        className="menu-back-btn"
                        onClick={() => setMoreMenuView('main')}
                    >
                        ← Back to More
                    </button>

                    {(activeStatuses.length > 0 || currentStatus?.type === 'dnd' || currentStatus?.type === 'focus') && (
                        <>
                            <div className="availability-status-card">
                                {activeStatuses.length > 1 ? (
                                    <>
                                        <p className="availability-status-title">Active Statuses</p>

                                        <div className="active-status-list">
                                            {activeStatuses.map((status) => (
                                                <button
                                                    key={status._id || status.id}
                                                    type="button"
                                                    className="active-status-list-item"
                                                    onClick={() => setSelectedActiveStatus(status)}
                                                >
                                                    <span className="active-status-name">
                                                        {status.userName ||
                                                            status.userId?.name ||
                                                            status.userId?.fullName ||
                                                            'Lynn'}
                                                    </span>

                                                    <span className="active-status-details">
                                                        <span className="active-status-type">
                                                            {status.icon || '⛔'} {status.blockLabel || status.text || status.label || 'Do Not Disturb'}
                                                        </span>

                                                        <span className="active-status-time">
                                                            {formatStatusTime(status)}
                                                        </span>
                                                        <button
                                                            type="button"
                                                            className="end-block-now-btn"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleTurnOffSingleStatus(status);
                                                            }}
                                                        >
                                                            End Now
                                                        </button>
                                                    </span>
                                                </button>
                                            ))}
                                        </div>

                                    </>
                                ) : (
                                    <div className="availability-status-row">
                                        <div>
                                            <span className="availability-staff-name">
                                                {statusToShow?.userName ||
                                                    statusToShow?.userId?.name ||
                                                    statusToShow?.userId?.fullName ||
                                                    'Lynn'}
                                            </span>

                                            <p className="availability-status-title">
                                                {statusToShow?.blockLabel ||
                                                    statusToShow?.text ||
                                                    statusToShow?.label ||
                                                    'Active Block'}
                                            </p>

                                            <p>
                                                {statusToShow?.untilTime ||
                                                    formatStatusTime(statusToShow)}
                                            </p>
                                        </div>
                                    </div>
                                )}
                            </div>

                            <button
                                type="button"
                                className="turn-off-dnd-btn"
                                onClick={async () => {
                                    try {
                                        const enabledSchedules = savedDndSchedules.filter(
                                            (item) => item.enabled
                                        );

                                        await Promise.all(
                                            enabledSchedules.map((schedule) => {
                                                const scheduleId = schedule._id || schedule.id;

                                                return fetch(`/api/focus-schedules/${scheduleId}`, {
                                                    method: 'PATCH',
                                                    headers: getAuthHeaders(),
                                                    body: JSON.stringify({ enabled: false }),
                                                });
                                            })
                                        );

                                        const statusToTurnOff =
                                            selectedActiveStatus || currentStatus;

                                        const availabilityId =
                                            statusToTurnOff?.id || statusToTurnOff?._id;

                                        console.log('Turning off availabilityId:', availabilityId);

                                        if (availabilityId) {
                                            const availabilityRes = await fetch(`/api/availability/${availabilityId}`, {
                                                method: 'PATCH',
                                                headers: getAuthHeaders(),
                                                body: JSON.stringify({ enabled: false }),
                                            });

                                            if (!availabilityRes.ok) {
                                                console.error('Availability turn-off failed:', await availabilityRes.text());
                                                throw new Error('Failed to turn off availability status');
                                            }
                                        } else {
                                            console.warn('No availability id found on currentStatus:', currentStatus);
                                        }

                                        setSavedDndSchedules((prev) =>
                                            prev.map((item) => ({
                                                ...item,
                                                enabled: false,
                                            }))
                                        );

                                        const formatScheduleTime = (time) => {
                                            if (!time) return '';

                                            const [hour, minute] = time.split(':');

                                            return new Date(2000, 0, 1, hour, minute).toLocaleTimeString([], {
                                                hour: 'numeric',
                                                minute: '2-digit',
                                            });
                                        };

                                        setCurrentStatus(null);
                                        localStorage.removeItem('kuddlecore_active_status');
                                        window.dispatchEvent(new Event('kuddle:availability-updated'));

                                        setShowMoreMenu(false);
                                        setMoreMenuView('main');


                                    } catch (err) {
                                        console.error(err);
                                        toast.error('Unable to turn off');
                                    }
                                }}
                            >
                                {(selectedActiveStatus || currentStatus)?.type === 'focus'
                                    ? 'Turn off Focus Mode'
                                    : 'Turn off Do Not Disturb'}
                            </button>
                        </>
                    )}

                </>
            )
            }
        </div >
    );
};

export default TopMoreMenu;